//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "max-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    maxValue: {
      get: function get() {
        return this.optionModel['max'];
      },
      set: function set(newValue) {
        if (!newValue || isNaN(newValue)) {
          this.optionModel.max = null;
        } else {
          this.optionModel.max = Number(newValue);
        }
      }
    }
  }
};